import { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react/index'
import { withTranslation } from '../../i18n'

import PostGridList from './PostGridList'


@inject('store')
@observer
class PostGrid extends Component {
  static propTypes = {
    categories: PropTypes.arrayOf(PropTypes.string),
    search: PropTypes.string,
    author: PropTypes.number,
    store: PropTypes.instanceOf(Object).isRequired,
    i18n: PropTypes.instanceOf(Object).isRequired
  }

  static defaultProps = {
    search: '',
    author: null,
    categories: []
  }

  loadMore = () => {
    this.getData(true)
  }

  getData(more = false) {
    const {
      i18n: { language }, store, categories, search, author
    } = this.props
    const query = { categories, search, author }
    store.loadPosts({ language, query, more })
  }

  componentDidMount() {
    this.getData()
  }

  componentDidUpdate(prevProps) {
    if (this.props.i18n.language !== prevProps.i18n.language || this.props.categories !== prevProps.categories
      || this.props.search !== prevProps.search || this.props.author !== prevProps.author) {
      this.getData()
    }
  }

  render() {
    const {
      store: { posts, postSearch: { hasMore } }
    } = this.props

    return (
      <PostGridList posts={posts} hasMore={hasMore} loadMore={this.loadMore} />
    )
  }
}

export default withTranslation(['magazine', 'common', 'auth', 'reset-password', 'contacts'])(PostGrid)
